<script lang="ts">
  export let error: string | null = null;
  export let onRetry: (() => void) | null = null;
</script>

{#if error}
  <div class="error-container">
    <div class="error-content">
      <h2>Something went wrong</h2>
      <p>{error}</p>
      {#if onRetry}
        <button on:click={onRetry} class="retry-button">
          Try Again
        </button>
      {/if}
    </div>
  </div>
{/if}

<style>
  .error-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background: rgba(220, 53, 69, 0.95);
    color: white;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    max-width: 400px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

  .error-content h2 {
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
  }

  .error-content p {
    margin: 0 0 1.5rem 0;
    line-height: 1.4;
  }

  .retry-button {
    background: white;
    color: #dc3545;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s;
  }

  .retry-button:hover {
    background: #f8f9fa;
  }
</style>